/* istanbul ignore next */
const ACTIONS = {
    SET_SOFTWARE_NAME: 'SET_SOFTWARE_NAME',
    SET_SOFTWARE_ID: 'SET_SOFTWARE_ID',
    SET_SYSTEM_ID: 'SET_SYSTEM_ID',
    SOFTWARE_DETAILS_SERVICE_ERROR: 'SOFTWARE_DETAILS_SERVICE_ERROR',
    TOGGLE_SW_DETAILS_CONTINUE_BUTTON: 'TOGGLE_SW_DETAILS_CONTINUE_BUTTON',
    GET_SOFTWARE_SUGGESTIONS: 'GET_SOFTWARE_SUGGESTIONS',
    DISMISS_SUGGESTION_DROPDOWN: 'DISMISS_SUGGESTION_DROPDOWN',
    SOFTWARE_NAME_ERROR: 'SOFTWARE_NAME_ERROR',
    GET_SOFTWARE_SUGGESTIONS_SUCCESS: 'GET_SOFTWARE_SUGGESTIONS_SUCCESS',
    ENABLE_SOFTWARE_ID_FIELD: 'ENABLE_SOFTWARE_ID_FIELD',
    SET_SOFTWARE_ID_READ_ONLY: 'SET_SOFTWARE_ID_READ_ONLY',
    TOGGLE_FIELD_VIEW: 'TOGGLE_FIELD_VIEW',
    SUBMIT_SOFTWARE_DETAILS: 'SUBMIT_SOFTWARE_DETAILS',
    VALIDATE_SOFTWARE_DETAILS: 'VALIDATE_SOFTWARE_DETAILS',
    SET_FIELD_ERROR: 'SET_FIELD_ERROR',
    SHOW_SOFTWARE_ID_HELP_PANEL: 'SHOW_SOFTWARE_ID_HELP_PANEL',
    DISMISS_ALERT_BOX: 'DISMISS_ALERT_BOX',
    SET_EDIT_STATUS: 'SET_EDIT_STATUS',
    PRE_POPULATE_LOCAL_STATE_SOFTWARE: 'PRE_POPULATE_LOCAL_STATE_SOFTWARE',
    GET_ONBOARD_ADVERTISER_DETAILS_BY_EMAIL: 'GET_ONBOARD_ADVERTISER_DETAILS_BY_EMAIL',
    GET_ONBOARD_ADVERTISER_DETAILS_BY_EMAIL_SUCCESS: 'GET_ONBOARD_ADVERTISER_DETAILS_BY_EMAIL_SUCCESS',
    SHOW_SAME_SOFTWARE_MODAL: 'SHOW_SAME_SOFTWARE_MODAL'
};

/* istanbul ignore next */
const ACTION_CREATORS = {
    setSoftwareName(fieldVal) {
        return {
            type: ACTIONS.SET_SOFTWARE_NAME,
            payload: {
                fieldVal
            }
        };
    },

    setSystemId(fieldVal) {
        return {
            type: ACTIONS.SET_SYSTEM_ID,
            payload: {
                fieldVal
            }
        };
    },

    getSoftwareSuggestions(searchString) {
        return {
            type: ACTIONS.GET_SOFTWARE_SUGGESTIONS,
            payload: {
                searchString
            }
        };
    },

    dismissSuggestionDropDown() {
        return {
            type: ACTIONS.DISMISS_SUGGESTION_DROPDOWN
        };
    },

    getSoftwareSuggestionsSuccess(softwareList) {
        return {
            type: ACTIONS.GET_SOFTWARE_SUGGESTIONS_SUCCESS,
            payload: {
                softwareList
            }
        };
    },

    setSoftwareId(fieldVal) {
        return {
            type: ACTIONS.SET_SOFTWARE_ID,
            payload: {
                fieldVal
            }
        };
    },

    enableSoftwareIdField(flag) {
        return {
            type: ACTIONS.ENABLE_SOFTWARE_ID_FIELD,
            payload: {
                flag
            }
        };
    },

    toggleFieldView(fieldName) {
        return {
            type: ACTIONS.TOGGLE_FIELD_VIEW,
            payload: {
                fieldName
            }
        };
    },

    submitSoftwareDetails(softwareDetails) {
        return {
            type: ACTIONS.SUBMIT_SOFTWARE_DETAILS,
            payload: {
                softwareDetails
            }
        };
    },

    validateSoftwareDetails(softwareDetails) {
        return {
            type: ACTIONS.VALIDATE_SOFTWARE_DETAILS,
            payload: {
                softwareDetails
            }
        };
    },

    toggleContinueButtonView() {
        return {
            type: ACTIONS.TOGGLE_SW_DETAILS_CONTINUE_BUTTON
        };
    },

    alertError(errorKey) {
        return {
            type: ACTIONS.SOFTWARE_DETAILS_SERVICE_ERROR,
            payload: {
                errorKey
            }
        };
    },

    setSoftwareNameError(errorKey) {
        return {
            type: ACTIONS.SOFTWARE_NAME_ERROR,
            payload: {
                errorKey
            }
        };
    },

    showSoftwareIdHelpPanel(flag) {
        return {
            type: ACTIONS.SHOW_SOFTWARE_ID_HELP_PANEL,
            payload: {
                flag
            }
        };
    },

    dismissAlertBox() {
        return {
            type: ACTIONS.DISMISS_ALERT_BOX
        };
    },

    setEditStatus(flag) {
        return {
            type: ACTIONS.SET_EDIT_STATUS,
            payload: {
                flag
            }
        };
    },

    prePopulateLocalState(publicUuid) {
        return {
            type: ACTIONS.PRE_POPULATE_LOCAL_STATE_SOFTWARE,
            payload: {
                publicUuid
            }
        };
    },


    getOnboardAdvertiserDetailsByEmail(systemId, emailAddress, accountUuid) {
        return {
            type: ACTIONS.GET_ONBOARD_ADVERTISER_DETAILS_BY_EMAIL,
            payload: {
                systemId,
                emailAddress,
                accountUuid
            }
        };
    },

    getOnboardAdvertiserDetailsByEmailSuccess(response) {
        let onboardAdvertiserDetails;
        if (response.errorCode) {
            onboardAdvertiserDetails = response;
        } else {
            onboardAdvertiserDetails = response.onboardAdvertiserDetails;
        }
        return {
            type: ACTIONS.GET_ONBOARD_ADVERTISER_DETAILS_BY_EMAIL_SUCCESS,
            payload: {
                onboardAdvertiserDetails
            }
        };
    },

    setSoftwareIdReadOnly(flag) {
        return {
            type: ACTIONS.SET_SOFTWARE_ID_READ_ONLY,
            payload: {
                flag
            }
        };
    },

    showSameSoftwareModal(flag) {
        return {
            type: ACTIONS.SHOW_SAME_SOFTWARE_MODAL,
            payload: {
                flag
            }
        };
    }
};

export default {
    ...ACTIONS,
    ...ACTION_CREATORS
};
